import { useGate } from 'statsig-react';

const useIsBFCM = (): boolean => {
  return useGate('bfcm_2024').value;
};

export default useIsBFCM;
